import Service from '../service';
export default {
  data: () => {
    return {
      info: {
        orgInfo: {}
      },
      fieldList: [],
      tableList: [],
      typeList: []
    };
  },

  watch: {
    $route: function () {
      this.action();
    }
  },

  computed: {
    address () {
      const region = this.info.region || {};
      let str = region.province;
      if (region.city && region.city !== region.province) {
        str += '-' + region.city;
      }
      if (region.district) {
        str += '-' + region.district;
      }
      if (region.town) {
        str += '-' + region.town;
      }
      if (region.village) {
        str += '-' + region.village;
      }
      if (this.info.address && region.province) {
        str += '-' + this.info.address;
      }
      return str;
    }
  },

  created () {
    this.action();
  },

  methods: {
    back() {
      this.$router.back();
    },

    action() {
      Service.getDetail({ id: this.$route.query.id}).then(res => {
        this.info = res;
        this.fieldList = res.template.fields || [];
        this.getList();
      });
      Service.getSubTypeList().then(res => {
        this.typeList = res;
      });
    },

    toDetail(item) {
      this.$router.push('/supply-and-demand/detail?id=' + item._id);
    },
    getList() {
      Service.getDemandList({
        subType: this.info.subType,
        limit: 6,
        type: this.info.type,
        tId: '66aaf74f247b9fffdb5eba08'
      }).then(res => {
        this.tableList = res.result.filter(item => item._id !== this.info._id);
        this.tableList = this.tableList.slice(0, 5);
      });
    }
  }
};
